import { Button } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const CarouselNavButtonStyled = styled(Button)`
  ${({ theme }) => css`
    background-color: ${theme.colors.white} !important;
    height: ${theme.spacings[800]} !important;
    width: ${theme.spacings[800]} !important;
  `}
`;

export const CarouselViewStyle = (base) => ({
  ...base,
  alignItems: 'center',
  display: 'flex ',
  height: 'calc(100vh - 24px)',
  margin: '2vh auto',
  justifyContent: 'center',
  '& > img': {
    maxHeight: 'calc(100vh - 54px)',
  },
});

export const CarouselContainerStyle = (base) => ({
  ...base,
  height: '100vh',
});

export const ModalBlanketStyle = (base) => ({
  ...base,
  backgroundColor: 'rgba(0, 0, 0, 0.55)',
});
